import { makeUrl, routes, useRouteMatch } from "../lib/urls";
import type { RouteNode } from "../lib/urls/types";
import { RightTabs, TabHeaderBar, Tabs } from "./TabHeader";
import { TabLink } from "./TabLink";

type Context =
  | { kind: "space"; spaceId: string }
  | { kind: "personal" }
  | { kind: "favorites" }
  | { kind: "recents" };

type Props = {
  context: Context;
  workflowsCount: number;
  linksCount: number;
};

function tabRoutes(context: Context): {
  workflows: RouteNode;
  links: RouteNode;
  workflowsHref: string;
  linksHref: string;
  leaderboardHref?: string;
} {
  switch (context.kind) {
    case "space":
      return {
        workflows: routes.space,
        links: routes.space.links,
        workflowsHref: makeUrl(routes.space, { spaceId: context.spaceId }),
        linksHref: makeUrl(routes.space.links, { spaceId: context.spaceId }),
        leaderboardHref: makeUrl(routes.space.leaderboard, {
          spaceId: context.spaceId,
        }),
      };
    case "personal":
      return {
        workflows: routes.personal,
        links: routes.personal.links,
        workflowsHref: makeUrl(routes.personal),
        linksHref: makeUrl(routes.personal.links),
      };
    case "favorites":
      return {
        workflows: routes.favorites,
        links: routes.favorites.links,
        workflowsHref: makeUrl(routes.favorites),
        linksHref: makeUrl(routes.favorites.links),
      };
    case "recents":
      return {
        workflows: routes.recents,
        links: routes.recents.links,
        workflowsHref: makeUrl(routes.recents),
        linksHref: makeUrl(routes.recents.links),
      };
  }
}

export function PagesTabHeader({ context, workflowsCount, linksCount }: Props) {
  const { links, workflowsHref, linksHref, leaderboardHref } =
    tabRoutes(context);
  const [isLinks] = useRouteMatch(links);
  const [isLeaderboard] = useRouteMatch(routes.space.leaderboard);
  const isWorkflows = !isLinks && !isLeaderboard;

  return (
    <TabHeaderBar>
      <Tabs>
        <TabLink
          to={workflowsHref}
          active={isWorkflows}
          icon="product-workflows"
          label="Workflows"
          count={workflowsCount > 0 ? workflowsCount : null}
        />
        <TabLink
          to={linksHref}
          active={isLinks}
          icon="product-cases"
          label="Links"
          count={linksCount > 0 ? linksCount : null}
        />
      </Tabs>
      {leaderboardHref && (
        <RightTabs>
          <TabLink
            to={leaderboardHref}
            active={isLeaderboard}
            icon="crown"
            label="Leaderboard"
          />
        </RightTabs>
      )}
    </TabHeaderBar>
  );
}
